import React from "react";
import { FaYoutube, FaFacebook } from "react-icons/fa";
import style from "../../App.module.scss";

export const Footer = () => {
  return (
    <section id="contact" className={style.contact}>
      <div className={style.copy}>
        <div className={style.copyCol}>
          <b>© 2025 APPIDEA - Rapid Development Company</b>
          <br />
          ul. Chmielna 73 - VARSO Place
          <br />
          00-801 Warsaw, Poland
          <br />
        </div>
        <div className={style.socialMedia}>
          <a 
            href="https://www.youtube.com/@rapidshop_ai" 
            target="_blank" 
            rel="noopener noreferrer"
            className={style.socialButton}
            aria-label="YouTube"
          >
            <FaYoutube />
          </a>
          <a 
            href="https://www.facebook.com/rapidshopapp" 
            target="_blank" 
            rel="noopener noreferrer"
            className={style.socialButton}
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
        </div>
        <div className={style.copyCol}>
          We build modern applications for web, mobile and IoT. <br /> Let's
          talk about your project!<br />
          <a href="/rs-policy-privacy.pdf" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </div>
      </div>
    </section>
  );
};
